import { useMemo } from "react";
import { Box, Anchor, Text } from "grommet";
import Link from "next/link";
import { useRouter } from "next/router";
import styled from "styled-components";
import { useIsLarge } from "@cybertools/grommet/useIsLarge";
import { truncate } from "./helper";

const Ul = styled.ol`
  justify-content: ${({ justify = "flex-start" }) => justify};
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
`;

const home = { label: "Home", title: "Go to Home", href: "/" };

export default function Breadcrumb({ links, justify, ...rest }) {
  const { asPath } = useRouter();
  const large = useIsLarge();

  const currentLinks = useMemo(() => {
    const [first, ...restLinks] = links;
    const shouldTruncate = restLinks.length && !large;

    return [
      home,
      shouldTruncate ? { ...first, label: truncate(first.label) } : first,
      ...restLinks,
    ];
  }, [links, large]);

  return (
    <Box as="nav" aria-label="Breadcrumb" {...rest}>
      <Ul justify={justify}>
        {currentLinks.map(({ href, ...linkProps }, index) => {
          const last = currentLinks.length === index + 1;

          return (
            <li key={index}>
              <Link href={href || asPath} passHref legacyBehavior>
                <Anchor
                  size={large ? "small" : "xsmall"}
                  data-ga={`breadcrumb::click::${linkProps.label.toLowerCase()}`}
                  {...(last && { "aria-current": "page", color: "#bbb" })}
                  {...linkProps}
                />
              </Link>
              {!last && (
                <Text
                  size="small"
                  color="dark-4"
                  margin={{ horizontal: "xsmall" }}
                >
                  /
                </Text>
              )}
            </li>
          );
        })}
      </Ul>
    </Box>
  );
}
